// about vuex
// The MIT License (MIT)
//
// Copyright (c) 2015-present Evan You
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

// oss一覧
import { mapState, mapActions } from 'vuex';
import { closeAppAllModal } from "../share/util/dialog";

// その他外部ファイル一覧
import alert from '../share/alert';
import api from '../common/api';
import handler from '../share/util/apiResultValidator';
import util from '../share/util/utils';
import config from '../share/config';
import flowNavigation from '../share/components/vue/FlowNavigation';
import loading from '../share/components/vue/ProcessingIcon';
import session from '../share/session';
import cstmTable from '../share/components/vue/PaginationTable';
import cstmPagination from '../share/components/vue/Pagination';
import lngSwitch from '../share/util/languageSwitching';
import { openManual } from '../share/util/openManual';
import saml from '../../../manage/src/share/util/saml';
import { createDropDownItems, showMoveProjectConfirmModal, showMoveMenuConfirmModal, clickedMoveConfirm, reproDataDownload, downloadReproFileFunc, resolveReproDataItemsByLanguage, updateSelectedLang, showUserInfoModal } from './utils';
import { TAP_START, TAP_VERSION_INFO, TAP_USER_INFO, TAP_LANGUAGE, TAP_UNIT, TAP_PERSONAL_DATA, TAP_USER_TERMS, TAP_LOG_OUT, TAP_TECH_MANUAL, TAP_TO_PROJECT, TAP_TO_MENU, CONVERT_TO_DISPLAY_NAME, TAP_REPRO_FILE_DOWNLOAD } from './constants';

export default {
  name: 'App',
  data() {
    return {
      showModalUser: false,
      showModalVersion: false,
      showModalLang: false,
      showModalConditions: false,
      showReproFileDownloadModal: false,
      isShowNavigation: false,
      isCloudConnector: false,
      isVoltage: false,
      voltageStyle: '',
      selectedLanguage: 'en',
      userInfo: {},
      userConditions: '',
      modalLoading: false,
      isHover: false,
      isHoverTroubleshoot: false,
      dropdownItems: [],
      headerDisabled: false,
      userIconDisabled: false,
      isAppProcessing: false,
      serviceVersionFields: [
        { name: 'module', label: 'message.column_module_name' },
        { name: 'version', label: 'message.column_detailed_version' },
        { name: 'release_time', label: 'message.column_renewal_date' },
      ],
      serviceVersionItems: [],
      systemReleasedTime: 0,
      userConditionsTitle: this.$t('message.menu_label_terms'),
      isMoveLogin: true,
      isMirrorSiteFlg: false,
      moveConfirmType: '',
      showModalMoveConfirm: false,
      moveConfirmTitle: this.$t('message.menu_vehicle_to_project'),
      moveConfirmMessage: '',
      projectsBuff: [],
      selectedDataSource: '',
      reproDataItems: [],
      reproDataItemsLanguageCache: { language: null, items: [] },
      reproDataBaseList: [],
      reproFileSelectedLanguage: 'ja',
      defaultLang: 'ja',
      translationLangs: [],
      reproPageSize: 10, reproCurrentPage: 1, reproTotalItemLength: 0,
      fileUrl: null,
    };
  },
  components: {
    'flowNavigation': flowNavigation,
    'processing-view': loading,
    'cstm-table': cstmTable,
    'cstm-pagination': cstmPagination,
  },
  computed: {
    ...mapState({
      headerTitleID(state) {
        let title = state.app.headerTitleID;
        if (!title) {
          title = "message.header_signin";
        }
        return title;
      },
      loggedIn: state => state.auth.loggedIn,
      mainContainerStyle: state => state.app.mainContainerStyle,
      languageList: state => state.fileResources.constLangList,
      breadCrumbs: state => state.app.breadCrumbs,
      headerType: state => state.app.headerType,
      flowNavigationType: state => state.app.flowNavigationType,
      userProperty: state => state.userProperty,
      appConnectStatus(state) {
        const pairingId = state.netAppConnector.pairingAppId;
        if (!pairingId) {
          return this.$t('message.label_pairing_disconnected');
        }
        const valueList = pairingId.split('@');
        const name = valueList.length > 1 ? valueList[0] : pairingId;
        return name;
      },
      voltage(state) {
        const value = state.vehicle.voltage;
        if (value === null) {
          // 電圧値 エラー
          this.voltageStyle = 'danger';
          return '--.--V';
        }
        // 電圧が取得出来た場合
        if (value === 0) {
          // 電圧値 エラー
          this.voltageStyle = 'danger';
        }
        else if (0 < value && value <= 10.0) {
          // 電圧値 警告
          this.voltageStyle = 'warning';
        }
        else if (10.0 < value && value <= 14.0) {
          // 電圧値 正常
          this.voltageStyle = '';
        }
        else if (14.0 < value) {
          // 電圧値 警告
          this.voltageStyle = 'warning';
        }
        return `${value}V`;
      },
      viewProcessMode: state => state.app.viewProcessMode,
      language: state => state.systems.language,
      versionInfo: state => state.systems.versionInfo,
      displayVersion: state => state.systems.versionInfo.displayVersion,
      copyright: state => state.systems.versionInfo.copyright,
      samlAccountList: state => state.systems.samlAccountList,
      isTimeoutLocked: state => state.app.isTimeoutLocked,
      specials: state => state.fileResources.specialCompanies,
      processing(state) {
        if (state.app.processingIcon || this.isAppProcessing) {
          return true;
        }
        return false;
      },
      currentProvider: state => state.provider.currentProvider,
      vehicleInfo: state => state.vehicle.vehicleInfo,
      isDataPlayback: state => state.userProperty.functionAvailability[config.EXECUE_FUNCTION_TYPE_DATAPLAYBACK],
      isMovedVehicleToProject: state => state.cache.isMovedVehicleToProject,
      isTestMode: state => state.netAppConnector.isTestMode,
      unitOptions: state => state.masterResources.targetUnits,
      masterTranslations: state => state.fileResources.translations,
    }),
    reproDataColumn() {
      const separator = '/';
      return [
        { key: 'targetUnit', label: this.$t('message.header_vehicle_system_table_unit') },
        { key: 'serviceNews', label: this.$t('message.label_vehicle_system_service_news') + separator + this.$t('message.label_vehicle_system_program_title') },
        { key: 'fileName', label: this.$t('message.column_repro_file_name') },
        { key: 'updateDetails', label: this.$t('message.header_vehicle_file_table_countermeasure_content') + separator + this.$t('message.header_vehicle_file_table_program_content') },
        { key: 'releaseDate', label: this.$t('message.header_vehicle_file_table_release_date') },
        { key: 'download', label: this.$t('message.button_vehicle_system_download_zip') },
      ];
    },
    reproDataItemsPaged() {
      const start = (this.reproCurrentPage - 1) * this.reproPageSize;
      const end = this.reproCurrentPage * this.reproPageSize;
      return (this.reproDataItems || []).slice(start, end);
    },
  },

  watch: {
    language: {
      immediate: true,
      handler(val) {
        this.selectedLanguage = val;
        this.$i18n.locale = val;
      }
    },
    versionInfo: {
      handler() {
        // headerType、versionInfoの順番で取得するため
        // headerTypeのタイミングのみだとversionInfoが空の状態になってしまうので
        // versionInfo取得後に再度dropdownItemアイテム初期化
        this.dropdownItems = createDropDownItems(this);
      }
    },
    headerType: {
      immediate: true,
      handler() {
        // dropdownItemアイテム初期化
        this.dropdownItems = createDropDownItems(this);
      }
    },

    flowNavigationType: {
      immediate: true,
      handler(val) {
        if (val === config.NAVIGATION_NONE) {
          this.isShowNavigation = false;
        } else {
          this.isShowNavigation = true;
        }
      }
    },

    // リプロ状態の監視
    viewProcessMode(val) {
      if (val === config.PROCESS_IDLING) {
        this.headerDisabled = false;
        this.userIconDisabled = false;
        this.setPFCReuseStatus(false);
      }
      else if (val === config.PROCESS_REPRO_PROCESSING) {
        this.headerDisabled = true;
        this.userIconDisabled = true;
      }
      else if (val === config.PROCESS_REPRO_COMPLETED) {
        this.headerDisabled = true;
        this.userIconDisabled = false;
      }
    },

    '$route.name': {
      immediate: true,
      handler(val) {
        this.updateDropdownItems(val);
      }
    },
  },

  methods: {
    ...mapActions('app', ['setclientHeight']),
    ...mapActions('auth', ['logout', 'resetSession', 'updateLastOperationTime']),
    ...mapActions('reprogram', ['setPFCReuseStatus']),
    ...mapActions('systems', ['setLanguage', 'updateLanguage']),
    ...mapActions('fileResources', ['checkSBRUser']),
    ...mapActions('cache', ['cacheDiagProjectList', 'cacheProjectDetails', 'cacheIsMovedVehicleToProject', 'cacheProjectDataSource']),

    initializeVersionInfo() {
      this.serviceVersionItems = Object.entries(this.versionInfo.serviceInfo)
        .map(([systemName, systemInfo]) => {
          return {
            module: CONVERT_TO_DISPLAY_NAME[systemName] ? CONVERT_TO_DISPLAY_NAME[systemName] : "",
            version: systemInfo.version ? systemInfo.version : "",
            release_time: systemInfo.released_time ? util.timeConverter(systemInfo.released_time, null, "day") : ""
          };
        })
        .sort((rightValue, leftValue) => rightValue.module.localeCompare(leftValue.module));
      this.systemReleasedTime = this.versionInfo.systemInfo.released_time ? util.timeConverter(this.versionInfo.systemInfo.released_time, null, "day") : "";
    },

    isShowTapVersionInfo() {
      return this.versionInfo &&
        this.versionInfo.systemInfo &&
        this.versionInfo.serviceInfo;
    },

    didTapDropdownItem(type) {
      switch (type) {
        case TAP_START.type:
          // start画面へ移行
          this.$router.push({ name: 'home' }, () => { }, () => { });
          break;
        case TAP_TO_PROJECT.type:
          showMoveProjectConfirmModal(this, type);
          break;
        case TAP_TO_MENU.type:
          showMoveMenuConfirmModal(this, type);
          break;
        case TAP_VERSION_INFO.type:
          this.initializeVersionInfo();
          this.showVersionInfoModal();
          break;
        case TAP_LANGUAGE.type:
          this.showlanguageModal();
          break;
        case TAP_UNIT.type:
          this.didTapChangeUnit();
          break;
        case TAP_USER_INFO.type:
          showUserInfoModal(this);
          break;
        case TAP_PERSONAL_DATA.type:
          this.showUserConditionsModal("personal_data_agreement");
          break;
        case TAP_USER_TERMS.type:
          this.showUserConditionsModal("useragreement");
          break;
        case TAP_TECH_MANUAL.type:
          openManual(this, config.MANUAL_TECH);
          break;
        case TAP_REPRO_FILE_DOWNLOAD.type:
          reproDataDownload(this);
          break;
        case TAP_LOG_OUT.type:
          this.taplogout(true);
          break;
      }
    },

    /**
     * 完全ログアウト処理
     * @param {boolean} isDialog 確認ダイアログ表示判定（true: 表示、false: 非表示）
    */
    async taplogout(isDialog) {
      // SBRユーザーかチェック
      let isSBRUser = await this.checkSBRUser(this.userProperty.companyId);
      if (util.isChinaResion()) {
        // 中国の場合は必ずログアウトするためここで isSBRUser を false に設定する。
        isSBRUser = false;
      }
      let logoutUrl = null;
      if (this.samlAccountList.length > 0) {
        logoutUrl = this.samlAccountList[0].sloLogoutUrl;
      }
      // プロバイダー情報がある場合は対応するプロバイダーのログアウトURLを設定(stg1環境用)
      const extractedAccount = saml.extractSamlAccount(this.samlAccountList, this.currentProvider);
      if (extractedAccount) logoutUrl = extractedAccount.sloLogoutUrl;
      if (logoutUrl) {
        // SAML連携ユーザーかチェック(ただし、SAML連携のSBRユーザーのみ完全ログアウトは実施しない)
        if (this.userProperty.userInfo.isExternalAuth && isSBRUser === false) {
          this.isMoveLogin = false;
        }
      }
      // ログアウト処理
      const SSM5Logout = async () => {
        // ログイン画面に遷移するかの情報を設定
        this.isMoveLogin = false;
        this.logout(this);
        // enable_sign_out_flowがtrueの場合はsloLogoutUrlをそのまま実施
        // enable_sign_out_flowがfalseの場合はsloLogoutUrlに「logout_uri」クエリパラメータを追加して実行
        if (extractedAccount.needSingleLogout && extractedAccount.sloLogoutUrl) {
          // サインアウトメニューからサインアウトする場合は、リダイレクトによる beforeunload イベントの発火を抑止
          window.removeEventListener('beforeunload', this.beforeunloadHandler, false);
          window.location.href = extractedAccount.sloLogoutUrl + "/logout";
          // url例: https://ssm5tst2subarunet.auth.ap-northeast-1.amazoncognito.com/logout?client_id=6iqlp1sl9119566474lrrh1bdm&logout_uri=https://soa-test2.sbr-dev.com/logout
        } else if (!extractedAccount.needSingleLogout && extractedAccount.sloLogoutUrl) {
          window.removeEventListener('beforeunload', this.beforeunloadHandler, false);
          window.location.href = extractedAccount.sloLogoutUrl;
          // url例: https://auth2.ids-idp-test.dev-idp.com/logout?client_id=6g862s44ggkaq8t5j54m0skdis&logout_uri=https://dev3.ssm-dev.com
        }
      };
      // 確認ダイアログ表示判定
      if (isDialog) {
        alert.showConfirmation(this, null, this.$t('message.confirm_signout_message'), () => {
          // ログアウト処理
          SSM5Logout();
        });
      } else {
        // ログアウト処理
        SSM5Logout();
      }
    },

    showVersionInfoModal() {
      this.showModalVersion = !this.showModalVersion;
    },

    didTapChangePassword() {
      this.showModalUser = false;
      this.$router.push(
        { name: 'changePassword' }, () => { }, () => { });
    },

    showlanguageModal() {
      // 情報の初期化
      this.selectedLanguage = this.language;
      this.showModalLang = true;
    },

    async didTapLanguage() {
      this.isAppProcessing = true;
      if (this.loggedIn) {
        // ログインしてる場合はサーバーに言語情報を設定する
        await this.updateLanguage({ userId: this.userProperty.userId, language: this.selectedLanguage, loadExtraMessages: true });
      }
      else {
        // ログインしていない場合は表示のみ変更をする
        this.setLanguage({ language: this.selectedLanguage });
      }
      this.showModalLang = false;
      this.isAppProcessing = false;
    },

    didTapChangeUnit() {
      this.$router.push(
        {
          name: 'changeUnit',
          params: {
            previousRoute: this.$router.currentRoute.value.name
          }
        }, () => { }, () => { });
    },

    async showUserConditionsModal(targetType = 'useragreement') {
      this.userConditionsTitle = (() => {
        if (targetType === 'useragreement') {
          return this.$t('message.menu_label_terms');
        }
        return this.$t('message.menu_label_personal_data');
      })();

      // 情報の初期化(画面を広く表示するため改行コードを設定)
      this.userConditions = '</br></br></br>';
      this.showModalConditions = true;
      const params = {
        target: targetType,
        language: this.language,
        service: config.SERVICE_REPRO
      };

      this.modalLoading = true;
      const response = await api.getParamCall(config.ADMIN, '/fileResources', params);
      this.modalLoading = false;

      handler.validate(
        handler.validateTypes.all,
        response, this, null,
        () => {
          // 処理が成功したときのコールバック処理
          const obj = JSON.parse(response.data.resources);
          this.userConditions = targetType === "useragreement" ? obj.user_agreement : obj.consent;
        },
        (result) => {
          // 処理が失敗した際にdialogが表示されていたら閉じる
          this.showModalConditions = false;
          // 処理が失敗したときのコールバック処理
          if (result.behaviorType === handler.behaviorTypes.logout) {
            this.logout(this);
          }
        }
      );
    },

    handleResize() {
      // ナビゲーションバーの表示有無を判断して高さ情報を設定する。
      const navigationHeight = this.isShowNavigation ? 0 : 45;
      const height = this.$refs.mainContainer.clientHeight - navigationHeight;
      this.setclientHeight(height);
    },

    logoutUser(event) {
      if (this.loggedIn) {
        // logout 処理内でタイマー停止・ログイン画面遷移を行わないので NULL 指定
        this.logout(null);
        if (event) {
          event.preventDefault();
          event.returnValue = '';
        }
      }
      this.$stopAllIntervals();
      this.$modalDialog.hide();
      // ブラウザバック実施時にはログイン画面に戻る
      this.$router.push({ name: 'login' }).catch(err => { }); // eslint-disable-line no-unused-vars
    },

    /**
     * beforeunloadイベント用処理
     * @param {*} event 
     */
    beforeunloadHandler(event) {
      if (this.loggedIn) {
        if (event) {
          event.preventDefault();
          event.returnValue = '';
        }
      }
    },

    /**
     * pagehideイベント用処理
     * beforeunload → Leave 確認後にページ破棄直前で発火する。
     * event.persisted = true (bfcache 退避) の場合はログアウトしない。
     * @param {PageTransitionEvent} event
     */
    pagehideHandler(event) {
      if (this.loggedIn && !event.persisted) {
        this.$store.dispatch('auth/logoutForPageLeave');
        this.$stopAllIntervals();
        this.$modalDialog.hide();
      }
    },

    // eslint-disable-next-line no-unused-vars
    handleTimer(event) {
      // ログインしていない、または大容量ファイルダウンロードなどの
      // 操作タイムアウトのカウントを停止したいときはイベントを発火させない
      if (!this.loggedIn || this.isTimeoutLocked) {
        return;
      }
      if (document.hidden) {
        // リプロ実行中状態の場合はタイマーを停止しないようにする
        if (this.viewProcessMode === config.PROCESS_REPRO_PROCESSING) {
          return;
        }
        session.pauseSessionTimer();
      } else {
        session.resumeSessionTimer();
      }
    },

    updateSelectedLanguage: function (selected) { updateSelectedLang(this, selected); },
    getReproDataItemsByLanguage(selected) {
      if (this.reproDataItemsLanguageCache.language === selected) return this.reproDataItemsLanguageCache.items || [];
      const items = resolveReproDataItemsByLanguage(this.reproDataBaseList, selected);
      this.reproDataItemsLanguageCache = { language: selected, items };
      return items;
    },
    selectedReproPage(currentPage) { this.reproCurrentPage = currentPage; },
    formatServiceNews(serviceNews) {
      if (Array.isArray(serviceNews)) {
        return serviceNews.join(lngSwitch.getServiceNewsSeparator());
      }
      return serviceNews || '';
    },
    async downloadReproFile(reproItem) { await downloadReproFileFunc(this, reproItem); },
    // トラブルシューティングフローを記したPDFを開く
    openTroubleshootingFlow() {
      const language = this.language === 'ja' ? 'jp' : 'en';
      const url = `troubleshooting/Troubleshootingflow_${language}.pdf`;
      window.open(`${window.location.origin}/${url}`, '_blank', 'width=1270,height=720');
    },
    closeAppAllModal() { closeAppAllModal(this); },
    /** 「プロジェクト詳細へ」,「Menuへ」確認ダイアログOKボタン押下 */
    onOkClickedMoveConfirm() {
      clickedMoveConfirm(this);
    },

    /**
     * 現在表示している画面に応じて、ドロップダウンアイテムの内容を更新する
     * @param {string} routeName 現在の表示画面のルート名
     */
    updateDropdownItems(routeName) {
      // リソースIDの関係で プロジェクト一覧、プロジェクト詳細、データ再生画面 では言語切り替えを不可にする
      const restrictedRoutes = ['diagProjectList', 'dataRecollection', 'diagProjectDetails'];
      // 制限画面 もしくは 制限画面から遷移した画面では言語選択ボタンを制限する
      const isRestricted = restrictedRoutes.includes(routeName) ||
        (routeName === 'changeUnit' && restrictedRoutes.includes(this.$route.params.previousRoute));

      isRestricted ? this.removeItemByType('language') : this.dropdownItems = createDropDownItems(this);
    },

    removeItemByType(type) {
      this.dropdownItems = this.dropdownItems.filter(i => i.type !== type);
    },

    /**
     * ブラウザの戻るボタン押下時の処理
     * @param {*} event event
     */
    popstateHandler(event) {
      // 戻るボタンの制御（想定回数分はログアウト処理しない）
      if (!event?.state?.isDisableBackClicks) {
        this.logoutUser(event);
      }
    },
  },
  mounted: function () {
    // eslint-disable-next-line max-lines
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
    // 表示言語一覧の準備
    const lang = util.getWindowNavigatorLanguage(config.LANGUAGE_LIST);
    this.setLanguage({ language: lang });
    // ミラーサイトの判定
    this.isMirrorSiteFlg = process.env.VUE_APP_BACKUP_TYPE ? true : false;
  },

  created() {
    // Handle browser back button event.
    window.addEventListener('hashchange', this.logoutUser, false);
    window.addEventListener('popstate', this.popstateHandler, false);
    // Handle tab/window close event.
    window.addEventListener('beforeunload', this.beforeunloadHandler, false);
    // pagehide: visibilitychange でのフラグ競合を補完するフォールバック
    window.addEventListener('pagehide', this.pagehideHandler, false);
    // Handle tab/window switch event.
    window.addEventListener('visibilitychange', this.handleTimer, false);
    // 予期しない操作タイムアウト抑止のためにマウス操作時に時間を更新
    window.addEventListener('click', async event => {
      event;
      this.updateLastOperationTime(new Date().getTime());
    }, false);
  },

  beforeUnmount() {
    window.removeEventListener('hashchange', this.logoutUser, false);
    window.removeEventListener('popstate', this.popstateHandler, false);
    window.removeEventListener('beforeunload', this.beforeunloadHandler, false);
    window.removeEventListener('pagehide', this.pagehideHandler, false);
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('visibilitychange', this.handleTimer, false);
  }
};